import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getWbs.query';

export const getWBSs = ({ latestVersion, filter, taskId }: QueryParams) => {
    const querystring = qs.stringify(
        { metaDataId: latestVersion, filter, taskId },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/getWBSs${querystring}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
